import { useIsMobile } from "../sections/constants";
import "./card.css";

const Card = ({ props }) => {
  const isMobile = useIsMobile();

  return (
    <a
      className="card_container"
      href={props.link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="img_container">
        {isMobile ? (
          <img
            className="portfolioImages"
            src={props.source[0]}
            alt="img"
            style={{
              width: "100%",
            }}
          />
        ) : (
          props.source.map((item, index) => (
            <img
              key={index}
              className="portfolioImages portfolioImages_grid"
              src={item}
              alt="img"
            />
          ))
        )}
      </div>
      <div className="text_container">
        <h3 className="title">{props.title}</h3>
        <small>{props.desc}</small>
      </div>
    </a>
  );
};

export default Card;
